import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-task',
  templateUrl: './mini-task.component.html',
  styleUrls: ['./mini-task.component.css']
})
export class MiniTaskComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
